export const ServiceContext = 'USE_VUE_SERVICE_CONTEXT';
export const DefaultContext = {};
